import { useContents } from "@/stores/contents"
import type { RouteRecordRaw } from "vue-router"

function getContentName() {
  const contentsStore = useContents()
  const contentName = contentsStore.content.title
  return contentName
}

const contentsRoutes: RouteRecordRaw[] = [
  {
    path: "versions/:contentId",
    name: "versionDetails",
    component: () => import("@/templates/contents/ContentDetails.vue"),
    meta: { breadcrumb: getContentName }
  }
  // {
  //   path: "news/:contentId",
  //   name: "newDetails",
  //   component: () => import("@/templates/contents/ContentDetails.vue"),
  //   meta: { breadcrumb: getNewsName }
  // },
  // {
  //   path: "faq/:contentId",
  //   name: "faqDetails",
  //   component: () => import("@/templates/contents/ContentDetails.vue"),
  //   meta: { breadcrumb: getFaqName }
  // }
]

export default contentsRoutes
